import {gql} from "@apollo/client";
import {mutate, query} from "../../lib/apollo";

export async function getProgramSet(id: number, sort: string, isAsc: boolean) {
    const q = gql`
      query q ($id: Int!, $sort: HpProgramSetCampusSort, $isAsc: Boolean) {
        hpProgramSet(id: $id, sort: $sort, isAsc: $isAsc) {
            id
            name
            campuses {
                name
                displayName
                active
                zipSearchId
                programSearchId
                zipCount
                zipWarning
                programWarning
                currentlyOnline
            }
        }
      }
    `;

    const response = await query(q, {id, sort, isAsc});
    return response && response.hpProgramSet ? response.hpProgramSet : null;
}

export async function getCampusZips(id: number, campusName: string) {
    const q = gql`
      query q ($id: Int!, $campusName: String!) {
        hpProgramSetCampusZips(id: $id, campusName: $campusName)
      }
    `;

    const response = await query(q, {id, campusName});
    return response && response.hpProgramSetCampusZips ? response.hpProgramSetCampusZips : [];
}

export async function getCampusStates(id: number, campusName: string) {
    const q = gql`
      query q ($id: Int!, $campusName: String!) {
        hpProgramSetCampusStates(id: $id, campusName: $campusName) {
            state
            name
            checked
        }
      }
    `;

    const response = await query(q, {id, campusName});
    return response && response.hpProgramSetCampusStates ? response.hpProgramSetCampusStates : [];
}

export async function campusAdd(id: number, name: string) {
    const q = gql`
      mutation m ($input: HpProgramSetCampusAddInput!) {
        hpProgramSetCampusAdd(input: $input)
      }
    `;

    const response = await mutate(q, {input: {id, name}});
    return !!(response && response.hpProgramSetCampusAdd);
}

export async function campusUpdate(id: number, oldName: string, name: string, displayName: string) {
    const q = gql`
      mutation m ($input: HpProgramSetCampusUpdateInput!) {
        hpProgramSetCampusUpdate(input: $input)
      }
    `;

    const response = await mutate(q, {input: {id, oldName, name, displayName}});
    return !!(response && response.hpProgramSetCampusUpdate);
}

export async function campusSetActive(id: number, name: string, active: boolean) {
    const q = gql`
      mutation m ($input: HpProgramSetCampusActiveInput!) {
        hpProgramSetCampusSetActive(input: $input)
      }
    `;

    const response = await mutate(q, {input: {id, name, active}});
    return !!(response && response.hpProgramSetCampusSetActive);
}

export async function campusDelete(id: number, name: string) {
    const q = gql`
      mutation m ($input: HpProgramSetCampusDeleteInput!) {
        hpProgramSetCampusDelete(input: $input)
      }
    `;

    const response = await mutate(q, {input: {id, name}});
    return !!(response && response.hpProgramSetCampusDelete);
}

export async function campusZipsReplace(id: number, name: string, zips: string) {
    const q = gql`
      mutation m ($input: HpProgramSetCampusZipsInput!) {
        hpProgramSetCampusZipsReplace(input: $input)
      }
    `;

    const response = await mutate(q, {input: {id, name, zips}});
    return !!(response && response.hpProgramSetCampusZipsReplace);
}

export async function campusStatesReplace(id: number, name: string, states: string[]) {
    const q = gql`
      mutation m ($input: HpProgramSetCampusStatesInput!) {
        hpProgramSetCampusStatesReplace(input: $input)
      }
    `;

    const response = await mutate(q, {input: {id, name, states}});
    return !!(response && response.hpProgramSetCampusStatesReplace);
}

export async function programSetImport(id: number, sourceId: number) {
    const q = gql`
      mutation m ($input: HpProgramSetImportInput!) {
        hpProgramSetImport(input: $input)
      }
    `;

    const response = await mutate(q, {input: {id, sourceId}});
    return !!(response && response.hpProgramSetImport);
}
